import { render, staticRenderFns } from "./form-installment2-desktop.vue?vue&type=template&id=f998b892&"
import script from "./form-installment2-desktop.vue?vue&type=script&lang=js&"
export * from "./form-installment2-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarSliderDeskVertical: require('/var/www/components/car/car-slider-desk-vertical.vue').default,CarTechMini: require('/var/www/components/car/car-tech-mini.vue').default,FormCreditCalculator: require('/var/www/components/form/form-components/form-credit-calculator.vue').default,InputsInput: require('/var/www/components/inputs/input.vue').default,CheckboxGroup: require('/var/www/components/checkbox/checkbox-group.vue').default})
